import { render, staticRenderFns } from "./reetag.vue?vue&type=template&id=8667d4d6&scoped=true"
import script from "./reetag.vue?vue&type=script&lang=js"
export * from "./reetag.vue?vue&type=script&lang=js"
import style0 from "./reetag.scss?vue&type=style&index=0&id=8667d4d6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8667d4d6",
  null
  
)

export default component.exports